import { Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-booster-reminder',
  templateUrl: './booster-reminder.component.html',
  styleUrls: ['./booster-reminder.component.scss'],
})
export class BoosterReminderComponent implements OnChanges {
  // details of booster reminder dialog
  @Input() boosterDialogDetails: {
    title: string;
    body: SafeHtml | string;
    confirmCta: string;
    closeCta: string;
    confirmCtaLink: string;
  };

  constructor(
    public modalCtrl: ModalController,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnChanges() {
    this.boosterDialogDetails.body = this.sanitizer.bypassSecurityTrustHtml(this.boosterDialogDetails.body.toString());
  }
}
